import { computed, createApp } from 'vue/dist/vue.esm-bundler.js'
{
  const appConfig = {
    compilerOptions: {
      // register any non-vue custom elements we can use inside this app
      isCustomElement: (tag) => ["g-map-2", "g-marker"].includes(tag),
    },    
    props: [
      'el'
    ],
    data(){
      return {
        loading: false,
        items: [],
        perPage: 12,
        totalItems: 1,
        maxPages: 1,
        postTypeLabel: 'Post',
        postType: 'post',
        mapShowing: false,
        noResultsMessage: 'No posts found.',
        // form data
        page: 1,
        search: '',
        zip: '',
        ariaAnnouncement: '',
        fetchOnClose: false,
      }
    },
    mounted(){
      // localize data from PHP
      this.postTypeLabel = this.el.getAttribute('data-post-type-name') || 'Post'
      this.postType = this.el.getAttribute('data-post-type') || 'post'
      this.noResultsMessage = (this.el.getAttribute('data-no-results-message') || '').trim() || 'No posts found.'

      // start the app
      const wasHistoryPulled = this.pullHistory()
      this.fetchItems(false, wasHistoryPulled)    
    },
    computed: {
      activeStateAbbreviations() {
        const states = new Set()
    
        this.items?.forEach(item => {
          item.company_locations?.forEach(loc => {
            const abbr = loc?.meta_acf?.state_province
            if (abbr) states.add(abbr.toUpperCase())
          })
        })
      return [...states]
     }
    },
    methods: {      
      setAriaAnnouncement(){
        this.ariaAnnouncement = {          
          postType: this.postType,
          search: this.search || null,
          pagination: this.items.length
            ? {
                start: this.page == this.maxPages
                  ? this.totalItems - this.items.length + 1
                  : 1 + (this.items.length * (this.page - 1)),
                end: this.page == this.maxPages
                  ? this.totalItems
                  : this.items.length * this.page,
                total: this.totalItems
              }
            : null
        }
      },    
      setPage(page){
        this.page = parseInt(page)
        this.fetchItems(false, true)
      },
      fetchItems(resetPage, setFocus){
        this.fetchOnClose = false

        if(resetPage){
          this.page = 1
        }

        this.loading = true

        this.setAriaAnnouncement()

        window.coolHelperFunctions.coolAjax({
          action: 'fetch_company_map_listing',
          post_type: this.postType,
          page: this.page,
          per_page: this.perPage,
          search: this.search,
          zip: this.zip,
        }, json => {
          this.loading = false
          this.items = json.items
          this.totalItems = json.totalItems
          this.maxPages = json.maxPages
          this.setAriaAnnouncement()
          this.pushHistory()
          this.$nextTick(() => {
            if(setFocus){
              //this.$refs.ariaAnnouncement?.focus()
              this.$refs.resultsHeading?.focus()
            }
          })
        }, err => {
          this.loading = false
          this.setAriaAnnouncement()
          alert(`Something went wrong. Please try again later. ${err}`)
        })
      },
      pushHistory(){
        const params = new URLSearchParams()
        if (this.page > 1) params.set('page', this.page)
        if (this.search) params.set('search', this.search)
        if (this.zip) params.set('zip', this.zip)

        const newUrl = params.toString()
          ? `${window.location.pathname}?${params.toString()}`
          : window.location.pathname

        if (window.location.href !== newUrl) {
          window.history.replaceState({}, '', newUrl)
        }
      },
      pullHistory(){
        let updated = false
        const params = new URLSearchParams(window.location.search)

        if (params.has('page')) { this.page = parseInt(params.get('page')); updated = true }
        if (params.has('search')) { this.search = params.get('search'); updated = true }
        if (params.has('zip')) { this.zip = params.get('zip'); updated = true }

        return updated
      },
    }
  }

  function initApp(){
    const els = document.querySelectorAll('.companies-map-listing--app')
    if(els.length){
      els.forEach(el => {
        const app = createApp(appConfig, { el })
        app.mount(el)
      })
    }
  }

  initApp()
}